import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import {AppSettingService} from '../../_services/app-setting.service';
import {forkJoin} from 'rxjs';
import {GarantiasIdoneas} from '../../_models/garantias-idoneas';
import {GarantiaIdoneasService} from '../../_services/garantia-idoneas.service';
import {TiposProductores} from '../../_models/tipos-productores';
import {TipoProductoresService} from '../../_services/tipo-producto.service';

@Component( {
  selector: 'app-tipo-productores-detalle',
  templateUrl: 'tipo-productores-detalle.component.html'
} )

export class TipoProductoresDetalleComponent implements OnInit {

  carInformacionInicial = true;
  tiposProductores: TiposProductores;


  constructor( private tipoProductoresService: TipoProductoresService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private navServicio: NavService,
               public appSettingService: AppSettingService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.tipoProductoresService.obtenerPorId( params[ 'id' ] ).subscribe( paquete => {
          this.tiposProductores = paquete;
          this.carInformacionInicial = false;
        } );
      }
    } );
  }






  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: `tipo-productores`,
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }





}
